import { PhoneLoginForm } from "@modules";

export const PagePhoneLogin = () => {
  return <PhoneLoginForm />;
};
